module.exports = __webpack_public_path__ + "static/media/client15.d157066a.webp";